/* eslint-disable camelcase */
export interface ChatGroupProps {
  id: string;
  label: string;
  custom_types?: string[];
  active: boolean;
  show_by_default: boolean;
  unread_messages: number;
  supports_custom_groups?: boolean;
  custom_groups?: ChatGroupProps[];
  custom_group_variant?: 'open' | 'select';
  maxUsersPerChannel?: number;
  can_be_archived?: boolean;
}

const defaultChatGroups: ChatGroupProps[] = [
  {
    id: 'customers',
    label: 'Customers',
    custom_types: ['customers', 'website_users'],
    active: true,
    show_by_default: false,
    unread_messages: 0,
    supports_custom_groups: false,
    maxUsersPerChannel: 1,
    can_be_archived: true,
  },
  {
    id: 'employees',
    label: 'Employees',
    custom_types: ['employees'],
    active: true,
    show_by_default: true,
    unread_messages: 0,
    supports_custom_groups: false,
    can_be_archived: true,
  },
  {
    id: 'community',
    label: 'Community',
    custom_types: ['community'],
    active: false,
    show_by_default: true,
    unread_messages: 0,
    supports_custom_groups: false,
    can_be_archived: true,
  },
  {
    id: 'opportunities',
    label: 'Job inbox',
    custom_types: ['opportunities'],
    active: false,
    show_by_default: true,
    unread_messages: 0,
    supports_custom_groups: false,
    can_be_archived: false,
  },
];

export default defaultChatGroups;
